import wx from 'weixin-js-sdk'
export default {
    wxShowMenu: function(shareData) {
      var _thiss = this;
      var localURL = window.location.href;
      var wxData = {
        title:'',
        info:'',
        shareurl:'',
        img:''
      };//分享配置信息
      var ifshare = shareData.ifshare;//是否开启分享
      var _this = shareData.that;
      // 微信分享配置
      let url = "/ac1/conference/shareInfo";
      let params = {};
      if(shareData.data == ''){
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            var box = res.posts;
            wxData ={
              title:box.title,
              info:box.desc,
              shareurl:box.link,
              img:box.img
            };
          }
        },function(res){
          console.log(res);
        });
      }
      _this.$get('/ac1/conference/wxJsConfig', {//获取config信息链接
        url: localURL
      }).then(function(res) {
        if (res.code == 1) {
          if(shareData.data != ''){
            wxData = shareData.data;
          }
          var getMsg = res.posts;
          wx.config({
            debug: false, //生产环境需要关闭debug模式
            beta: true,//用于方法未对外公开的情况
            appId: getMsg.appId, //appId通过微信服务号后台查看
            timestamp: getMsg.timestamp, //生成签名的时间戳
            nonceStr: getMsg.nonceStr, //生成签名的随机字符串
            signature: getMsg.signature, //签名
            jsApiList: getMsg.jsApiList
          });
          wx.ready(function() {
 　　　　　　　if (ifshare == '0') {
                //后端未开启分享则屏蔽分享菜单
                wx.hideAllNonBaseMenuItem();
                return;
              };
            //判断当前客户端版本是否支持指定JS接口
            wx.checkJsApi({
              jsApiList: getMsg.jsApiList, // 需要检测的JS接口列表，所有JS接口列表见附录2,
              success: function (res) {
                console.log(res)
                // 以键值对的形式返回，可用的api值true，不可用为false
                // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
              }
            });
            //分享到朋友圈
            wx.updateTimelineShareData({
              title: wxData.title, // 分享标题
              desc: wxData.info, //分享描述
              link: wxData.shareurl, // 分享链接
              imgUrl: wxData.img, // 分享图标
              success: function () {
                // 设置成功
              }
            })
            wx.onMenuShareTimeline({
              title: wxData.title, // 分享标题
              desc: wxData.info, //分享描述
              link: wxData.shareurl, // 分享链接
              imgUrl: wxData.img, // 分享图标
              success: function(res) {
                /*    // 用户确认分享后执行的回调函数
                var param = {
                  param: {
                    param1: Param1,
                    param2: Param2
                  }
                }
                //分享回调链接，用于自行记录判断之类
           _this.get('****', {
                  params: param
                }).then(function(res) {
                  if (res.status == 200 && res.data.result == 0) {
                    console.log('分享成功');
                  }
                }).catch(function(err) {
                  console.log(err);
                })*/
                console.log("分享朋友圈成功返回的信息为:", res);
              },
              cancel: function(res) {
                // 用户取消分享后执行的回调函数
                console.log("取消分享朋友圈返回的信息为:", res);
              }
            });
            //分享给朋友
            wx.updateAppMessageShareData({
              title: wxData.title, // 分享标题
              desc: wxData.info, //分享描述
              link: wxData.shareurl, // 分享链接
              imgUrl: wxData.img, // 分享图标
              success: function () {
                // 设置成功
              }
            })
            wx.onMenuShareAppMessage({
              title: wxData.title, // 分享标题
              desc: wxData.info, //分享描述
              link: wxData.shareurl, // 分享链接
              imgUrl: wxData.img, // 分享图标
              success: function(res) {
                // 用户确认分享后执行的回调函数
                /*  var param = {
                  param: {
                    param1: Param1,
                    param2: Param2
                  }
                }
                //分享回调链接，用于自行记录判断之类
               _this.get('****', {
                  params: param
                }).then(function(res) {
                  if (res.status == 200 && res.data.result == 0) {
                    console.log('分享成功');
                  }
                }).catch(function(err) {
                  console.log(err);
                })*/
                console.log("分享朋友圈成功返回的信息为:", res);
              },
              cancel: function(res) {
                // 用户取消分享后执行的回调函数
                console.log("取消分享给朋友返回的信息为:", res);
              }
            });

          });
          }
       })
   },
  wxInvoke:function(shareData,callback){
    var _this = shareData.that;
    var localURL = window.location.href;
    _this.$get('/ac1/conference/wxJsConfig', {//获取config信息链接
      url: localURL
    }).then(function(res) {
      if (res.code == 1) {
        var getMsg = res.posts;
        wx.config({
          debug: false, //生产环境需要关闭debug模式
          beta: true,//用于方法未对外公开的情况
          appId: getMsg.appId, //appId通过微信服务号后台查看
          timestamp: getMsg.timestamp, //生成签名的时间戳
          nonceStr: getMsg.nonceStr, //生成签名的随机字符串
          signature: getMsg.signature, //签名
          jsApiList: getMsg.jsApiList
        });
        wx.ready(function() {
            //调用开发票
            wx.invoke('chooseInvoiceTitle', {
              // 这里要传入参数
              "scene":"1"
            }, function (res) {
              // 这里处理调用结果
              // console.log(res);
              return callback(res);
            })

        });
      }
    })

   }
  }
